/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_pollwidget_addoption2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ 옵션 추가`)
};

const en_pollwidget_addoption2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Add option`)
};

const ja_pollwidget_addoption2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ オプションを追加`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const pollwidget_addoption2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pollwidget_addoption2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("pollwidget_addoption2", locale)
	if (locale === "ko") return ko_pollwidget_addoption2(inputs)
	if (locale === "en") return en_pollwidget_addoption2(inputs)
	return ja_pollwidget_addoption2(inputs)
};
export { pollwidget_addoption2 as "pollWidget_addOption" }